import { TemplatesPOSTRequest } from '../../interfaces/backend/TemplatesPOSTRequest';
import { Channels } from '../common/channelsEnum';

const internal = {
  page: {
    body: {
      container: { style: { 'background-color': '#FFFFFF' } },
      content: {
        computedStyle: {
          linkColor: '#FF819C',
          messageBackgroundColor: '#ffffff',
          messageWidth: '675.00px'
        },
        style: {
          color: '#000000',
          'font-family':
            "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
        }
      },
      type: 'mailup-bee-page-properties',
      webFonts: [
        {
          fontFamily:
            "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
          name: 'Montserrat',
          url: 'https://fonts.googleapis.com/css?family=Montserrat'
        },
        {
          fontFamily:
            "'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Geneva, Verdana, sans-serif",
          name: 'Lucida Sans',
          url: ''
        },
        {
          fontFamily: 'Tahoma, Verdana, Segoe, sans-serif',
          name: 'Tahoma',
          url: ''
        },
        {
          fontFamily:
            "'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
          name: 'Trebuchet MS',
          url: ''
        }
      ]
    },
    description: 'BF-ecommerce-template',
    rows: [
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  computedStyle: {
                    class: 'center fixedwidth',
                    width: '236.25px'
                  },
                  image: {
                    alt: '',
                    height: '512px',
                    href: '',
                    percWidth: 35,
                    prefix: '',
                    src: 'https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/d97fd431-21e3-4d48-83cf-6b434851a6cd/44be3800-3653-47a0-9e94-d6fa5d62278d/logo-placeholder-image.png',
                    target: '_self',
                    width: '512px'
                  },
                  style: {
                    'padding-bottom': '0px',
                    'padding-left': '0px',
                    'padding-right': '0px',
                    'padding-top': '0px',
                    width: '100%'
                  }
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-image',
                uuid: 'b3b5644c-f982-4d51-8456-c528db7dcba2'
              }
            ],
            style: {
              'background-color': '#f5f7ff',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '0px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '0px'
            },
            uuid: '6d600a8c-41f5-4951-9872-0bbe3583b034'
          }
        ],
        container: {
          style: {
            'background-color': '#f5f7ff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat'
          }
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top'
          },
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            color: '#333',
            width: '675px'
          }
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '53af1134-2fd6-4f35-b97c-516856aa6034'
      },
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  computedStyle: { hideContentOnMobile: false },
                  style: {
                    'padding-bottom': '30px',
                    'padding-left': '10px',
                    'padding-right': '10px',
                    'padding-top': '10px'
                  },
                  text: {
                    computedStyle: { linkColor: '#ff2d55' },
                    html: '<div class="txtTinyMce-wrapper" style="font-size: 12px; line-height: 14px; font-family: inherit;" data-mce-style="font-size: 12px; line-height: 14px; font-family: inherit;"><p style="font-size: 12px; line-height: 14px; word-break: break-word;" data-mce-style="font-size: 12px; line-height: 14px; word-break: break-word;"><span style="font-size: 18px; line-height: 21px;" data-mce-style="font-size: 18px; line-height: 21px;">You have a new comment:</span></p></div>',
                    style: {
                      color: '#4A4A4A',
                      'font-family': 'inherit',
                      'line-height': '120%'
                    }
                  }
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-text',
                uuid: '9b5bbe10-9124-4b32-b1b8-486e65fefd70'
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnMobile: false },
                  style: {
                    'padding-bottom': '30px',
                    'padding-left': '10px',
                    'padding-right': '10px',
                    'padding-top': '10px'
                  },
                  text: {
                    computedStyle: { linkColor: '#ff2d55' },
                    html: '<div class="txtTinyMce-wrapper" style="font-size: 12px; line-height: 14px; font-family: inherit;" data-mce-style="font-size: 12px; line-height: 14px; font-family: inherit;"><p style="font-size: 12px; line-height: 14px; word-break: break-word;" data-mce-style="font-size: 12px; line-height: 14px;"><span style="font-size: 18px; line-height: 21px;" data-mce-style="font-size: 18px; line-height: 21px;">{{comment}}</span></p></div>',
                    style: {
                      color: '#4A4A4A',
                      'font-family': 'inherit',
                      'line-height': '120%'
                    }
                  }
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-text',
                uuid: '3fa502c2-d082-4d20-8f89-a5a650383046'
              },
              {
                descriptor: {
                  button: {
                    href: 'https://notificationapi.com?commentId={{commentId}}',
                    label:
                      '<div class="txtTinyMce-wrapper" style="" data-mce-style=""><p dir="ltr" style="word-break: break-word;" data-mce-style="word-break: break-word;">DASHBOARD</p></div>',
                    percWidth: 29,
                    style: {
                      'background-color': '#37b877',
                      'border-bottom': '0px solid transparent',
                      'border-left': '0px solid transparent',
                      'border-radius': '4px',
                      'border-right': '0px solid transparent',
                      'border-top': '0px solid transparent',
                      color: '#ffffff',
                      direction: 'ltr',
                      'font-family': 'inherit',
                      'font-size': '20px',
                      'font-weight': '400',
                      'line-height': '200%',
                      'max-width': '100%',
                      'padding-bottom': '10px',
                      'padding-left': '40px',
                      'padding-right': '40px',
                      'padding-top': '10px',
                      width: 'auto'
                    },
                    target: '_blank'
                  },
                  computedStyle: {
                    height: 60,
                    hideContentOnMobile: false,
                    width: 216
                  },
                  style: {
                    'padding-bottom': '10px',
                    'padding-left': '10px',
                    'padding-right': '10px',
                    'padding-top': '10px',
                    'text-align': 'center'
                  }
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-button',
                uuid: '391e302c-9ad8-4739-a5bf-20fbc1b47dca'
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnMobile: false },
                  style: {
                    'padding-bottom': '10px',
                    'padding-left': '10px',
                    'padding-right': '10px',
                    'padding-top': '20px'
                  },
                  text: {
                    computedStyle: { linkColor: '#ff2d55' },
                    html: '<div class="txtTinyMce-wrapper" style="font-size:12px;line-height:14px;font-family:inherit;" data-mce-style="font-size:12px;line-height:14px;font-family:inherit;"><p style="font-size:12px;line-height:14px;word-break:break-word;" data-mce-style="font-size:12px;line-height:14px;word-break:break-word;"><span style="font-size:12px;line-height:14px;" data-mce-style="font-size:12px;line-height:14px;">Email editor pro tips:</span></p><ul><li style="font-size:12px;line-height:14px;word-break:break-word;" data-mce-style="font-size:12px;line-height:14px;word-break:break-word;">Select the logo and change it from the right panel</li><li style="font-size:12px;line-height:14px;word-break:break-word;" data-mce-style="font-size:12px;line-height:14px;word-break:break-word;">Select the button and change the URL from the right panel</li><li style="font-size:12px;line-height:14px;word-break:break-word;" data-mce-style="font-size:12px;line-height:14px;word-break:break-word;">You can do some crazy stuff (if, loops) if you want. <a href="https://docs.notificationapi.com/features/mergetags" target="_blank" style="text-decoration: underline;" rel="noopener">docs here</a>.</li></ul></div>',
                    style: {
                      color: '#4A4A4A',
                      'font-family': 'inherit',
                      'line-height': '120%'
                    }
                  }
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-text',
                uuid: 'b73e2595-b942-430b-a958-06a1b7b88e41'
              }
            ],
            style: {
              'background-color': 'transparent',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '30px',
              'padding-left': '20px',
              'padding-right': '20px',
              'padding-top': '30px'
            },
            uuid: '6d600a8c-41f5-4951-9872-0bbe3583b034'
          }
        ],
        container: {
          style: {
            'background-color': '#f5f7ff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat'
          }
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top'
          },
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            color: '#333',
            width: '675px'
          }
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: 'd26c6950-468e-446f-9378-48f000236984'
      },
      {
        columns: [
          {
            'grid-columns': 12,
            modules: [
              {
                descriptor: {
                  computedStyle: { hideContentOnMobile: false },
                  style: {
                    'padding-bottom': '10px',
                    'padding-left': '10px',
                    'padding-right': '10px',
                    'padding-top': '15px'
                  },
                  text: {
                    computedStyle: { linkColor: '#FF819C' },
                    html: '<div class="txtTinyMce-wrapper" style="font-size:12px;line-height:18px;font-family:&#39;Montserrat&#39;, &#39;Trebuchet MS&#39;, &#39;Lucida Grande&#39;, &#39;Lucida Sans Unicode&#39;, &#39;Lucida Sans&#39;, Tahoma, sans-serif;" data-mce-style="font-size:12px;line-height:18px;font-family:&#39;Montserrat&#39;, &#39;Trebuchet MS&#39;, &#39;Lucida Grande&#39;, &#39;Lucida Sans Unicode&#39;, &#39;Lucida Sans&#39;, Tahoma, sans-serif;"><p style="font-size:14px;line-height:21px;text-align:center;word-break:break-word;" data-mce-style="font-size:14px;line-height:21px;text-align:center;word-break:break-word;">My Company © All rights reserved</p></div>',
                    style: {
                      color: '#959595',
                      'font-family':
                        "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                      'line-height': '150%'
                    }
                  }
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-text',
                uuid: 'd185e63a-d160-413d-a284-e9d1e52563a8'
              },
              {
                descriptor: {
                  computedStyle: { hideContentOnMobile: false },
                  style: {
                    'padding-bottom': '10px',
                    'padding-left': '10px',
                    'padding-right': '10px',
                    'padding-top': '15px'
                  },
                  text: {
                    computedStyle: { linkColor: '#000000' },
                    html: '<div class="txtTinyMce-wrapper" style="font-size:12px;line-height:18px;font-family:&#39;Montserrat&#39;, &#39;Trebuchet MS&#39;, &#39;Lucida Grande&#39;, &#39;Lucida Sans Unicode&#39;, &#39;Lucida Sans&#39;, Tahoma, sans-serif;" data-mce-style="font-size:12px;line-height:18px;font-family:&#39;Montserrat&#39;, &#39;Trebuchet MS&#39;, &#39;Lucida Grande&#39;, &#39;Lucida Sans Unicode&#39;, &#39;Lucida Sans&#39;, Tahoma, sans-serif;"><p style="font-size:14px;line-height:21px;text-align:center;word-break:break-word;" data-mce-style="font-size:14px;line-height:21px;text-align:center;word-break:break-word;"><a href="{{notificationapi:unsubscribe_url}}" target="_blank" style="text-decoration: underline;" rel="noopener">Unsubscribe</a></p></div>',
                    style: {
                      color: '#959595',
                      'font-family': 'inherit',
                      'line-height': '150%'
                    }
                  }
                },
                locked: false,
                type: 'mailup-bee-newsletter-modules-text',
                uuid: '680886ad-f1d4-43a6-bb75-41c760b36e7b'
              }
            ],
            style: {
              'background-color': '#f5f7ff',
              'border-bottom': '0px solid transparent',
              'border-left': '0px solid transparent',
              'border-right': '0px solid transparent',
              'border-top': '0px solid transparent',
              'padding-bottom': '30px',
              'padding-left': '0px',
              'padding-right': '0px',
              'padding-top': '30px'
            },
            uuid: '1ef9a4e3-7005-405a-a190-7ad47e15ecf0'
          }
        ],
        container: {
          style: {
            'background-color': '#f5f7ff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat'
          }
        },
        content: {
          computedStyle: {
            hideContentOnDesktop: false,
            hideContentOnMobile: false,
            rowColStackOnMobile: true,
            rowReverseColStackOnMobile: false,
            verticalAlign: 'top'
          },
          style: {
            'background-color': '#ffffff',
            'background-image': 'none',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            color: '#333',
            width: '675px'
          }
        },
        empty: false,
        locked: false,
        synced: false,
        type: 'one-column-empty',
        uuid: '1c0a1fc7-2e83-40e2-88a9-44b2fb086713'
      }
    ],
    template: { name: 'template-base', type: 'basic', version: '2.0.0' },
    title: 'BF-ecommerce-template'
  },
  comments: {}
};

const html = `<!DOCTYPE html><html xmlns:v="urn:schemas-microsoft-com:vml" xmlns:o="urn:schemas-microsoft-com:office:office" lang="en"><head><title></title><meta http-equiv="Content-Type" content="text/html; charset=utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><!--[if mso]><xml><o:OfficeDocumentSettings><o:PixelsPerInch>96</o:PixelsPerInch><o:AllowPNG/></o:OfficeDocumentSettings></xml><![endif]--><!--[if !mso]><!--><link href="https://fonts.googleapis.com/css?family=Montserrat" 
rel="stylesheet" type="text/css"><!--<![endif]--><style>
*{box-sizing:border-box}body{margin:0;padding:0}a[x-apple-data-detectors]{color:inherit!important;text-decoration:inherit!important}#MessageViewBody a{color:inherit;text-decoration:none}p{line-height:inherit}.desktop_hide,.desktop_hide table{mso-hide:all;display:none;max-height:0;overflow:hidden}.image_block img+div{display:none} @media (max-width:695px){.mobile_hide{display:none}.row-content{width:100%!important}.stack .column{width:100%;display:block}.mobile_hide{min-height:0;max-height:0;max-width:0;overflow:hidden;font-size:0}.desktop_hide,.desktop_hide table{display:table!important;max-height:none!important}}
</style></head><body style="background-color:#fff;margin:0;padding:0;-webkit-text-size-adjust:none;text-size-adjust:none"><table class="nl-container" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff"><tbody><tr><td><table class="row row-1" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#f5f7ff">
<tbody><tr><td><table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff;color:#333;width:675px;margin:0 auto" width="675.00"><tbody><tr><td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;background-color:#f5f7ff;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0"><table 
class="image_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0"><tr><td class="pad" style="width:100%;padding-right:0;padding-left:0"><div class="alignment" align="center" style="line-height:10px"><div style="max-width:236.25px"><img src="https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/d97fd431-21e3-4d48-83cf-6b434851a6cd/44be3800-3653-47a0-9e94-d6fa5d62278d/logo-placeholder-image.png" 
style="display:block;height:auto;border:0;width:100%" width="236.25"></div></div></td></tr></table></td></tr></tbody></table></td></tr></tbody></table><table class="row row-2" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#f5f7ff"><tbody><tr><td><table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" 
style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff;color:#333;width:675px;margin:0 auto" width="675.00"><tbody><tr><td class="column column-1" width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;padding-bottom:30px;padding-left:20px;padding-right:20px;padding-top:30px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0"><table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" 
role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad" style="padding-bottom:30px;padding-left:10px;padding-right:10px;padding-top:10px"><div style="font-family:sans-serif"><div class style="font-size:12px;font-family:Montserrat,'Trebuchet MS','Lucida Grande','Lucida Sans Unicode','Lucida Sans',Tahoma,sans-serif;mso-line-height-alt:14.399999999999999px;color:#4a4a4a;line-height:1.2"><p 
style="margin:0;font-size:12px;mso-line-height-alt:14.399999999999999px"><span style="font-size:18px">You have a new comment:</span></p></div></div></td></tr></table><table class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad" style="padding-bottom:30px;padding-left:10px;padding-right:10px;padding-top:10px"><div style="font-family:sans-serif"><div class 
style="font-size:12px;font-family:Montserrat,'Trebuchet MS','Lucida Grande','Lucida Sans Unicode','Lucida Sans',Tahoma,sans-serif;mso-line-height-alt:14.399999999999999px;color:#4a4a4a;line-height:1.2"><p style="margin:0;font-size:12px;mso-line-height-alt:14.399999999999999px"><span style="font-size:18px">{{comment}}</span></p></div></div></td></tr></table><table class="button_block block-3" width="100%" border="0" cellpadding="10" cellspacing="0" role="presentation" 
style="mso-table-lspace:0;mso-table-rspace:0"><tr><td class="pad"><div class="alignment" align="center"><!--[if mso]>
<v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://notificationapi.com?commentId={{commentId}}" style="height:60px;width:216px;v-text-anchor:middle;" arcsize="7%" stroke="false" fillcolor="#37b877">
<w:anchorlock/>
<v:textbox inset="0px,0px,0px,0px">
<center style="color:#ffffff; font-family:'Trebuchet MS', Tahoma, sans-serif; font-size:20px">
<![endif]--><a href="https://notificationapi.com?commentId={{commentId}}" target="_blank" 
style="text-decoration:none;display:inline-block;color:#fff;background-color:#37b877;border-radius:4px;width:auto;border-top:0 solid transparent;font-weight:400;border-right:0 solid transparent;border-bottom:0 solid transparent;border-left:0 solid transparent;padding-top:10px;padding-bottom:10px;font-family:Montserrat,'Trebuchet MS','Lucida Grande','Lucida Sans Unicode','Lucida Sans',Tahoma,sans-serif;font-size:20px;text-align:center;mso-border-alt:none;word-break:keep-all"><span 
style="padding-left:40px;padding-right:40px;font-size:20px;display:inline-block;letter-spacing:normal"><span style="word-break:break-word;line-height:40px">DASHBOARD</span></span></a><!--[if mso]></center></v:textbox></v:roundrect><![endif]--></div></td></tr></table><table class="text_block block-4" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad" 
style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:20px"><div style="font-family:sans-serif"><div class style="font-size:12px;font-family:Montserrat,'Trebuchet MS','Lucida Grande','Lucida Sans Unicode','Lucida Sans',Tahoma,sans-serif;mso-line-height-alt:14.399999999999999px;color:#4a4a4a;line-height:1.2"><p style="margin:0;font-size:12px;mso-line-height-alt:14.399999999999999px"><span style="font-size:12px">Email editor pro tips:</span></p><ul 
style="line-height:1.2;mso-line-height-alt:14.399999999999999px;font-size:12px"><li>Select the logo and change it from the right panel</li><li>Select the button and change the URL from the right panel</li><li>You can do some crazy stuff (if, loops) if you want. <a href="https://docs.notificationapi.com/features/mergetags" target="_blank" style="text-decoration:underline;color:#ff2d55" rel="noopener">docs here</a>.</li></ul></div></div></td></tr></table></td></tr></tbody></table></td></tr>
</tbody></table><table class="row row-3" align="center" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#f5f7ff"><tbody><tr><td><table class="row-content stack" align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;background-color:#fff;color:#333;width:675px;margin:0 auto" width="675.00"><tbody><tr><td class="column column-1" 
width="100%" style="mso-table-lspace:0;mso-table-rspace:0;font-weight:400;text-align:left;background-color:#f5f7ff;padding-bottom:30px;padding-top:30px;vertical-align:top;border-top:0;border-right:0;border-bottom:0;border-left:0"><table class="text_block block-1" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad" 
style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:15px"><div style="font-family:'Trebuchet MS',Tahoma,sans-serif"><div class style="font-size:12px;font-family:Montserrat,'Trebuchet MS','Lucida Grande','Lucida Sans Unicode','Lucida Sans',Tahoma,sans-serif;mso-line-height-alt:18px;color:#959595;line-height:1.5"><p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px">My Company © All rights reserved</p></div></div></td></tr></table><table 
class="text_block block-2" width="100%" border="0" cellpadding="0" cellspacing="0" role="presentation" style="mso-table-lspace:0;mso-table-rspace:0;word-break:break-word"><tr><td class="pad" style="padding-bottom:10px;padding-left:10px;padding-right:10px;padding-top:15px"><div style="font-family:sans-serif"><div class 
style="font-size:12px;font-family:Montserrat,'Trebuchet MS','Lucida Grande','Lucida Sans Unicode','Lucida Sans',Tahoma,sans-serif;mso-line-height-alt:18px;color:#959595;line-height:1.5"><p style="margin:0;font-size:14px;text-align:center;mso-line-height-alt:21px"><a href="{{notificationapi:unsubscribe_url}}" target="_blank" style="text-decoration:underline;color:#000" rel="noopener">Unsubscribe</a></p></div></div></td></tr></table></td></tr></tbody></table></td></tr></tbody>
</table></td></tr></tbody></table><!-- End --></body></html>`;

const DefaultTemplates: {
  [key in Channels]: TemplatesPOSTRequest;
} = {
  EMAIL: {
    templateId: 'default',
    subject: 'New Comment',
    senderName: 'My Company',
    html,
    internal: JSON.stringify(internal)
  },
  INAPP_WEB: {
    templateId: 'default',
    instant: {
      title: `You have a new comment:
  {{comment}}`,
      imageURL:
        'https://app.notificationapi.com/notificationapiLogo.png?id={{commentId}}',
      redirectURL: 'https://notificationapi.com?commentId={{commentId}}'
    },
    batch: {
      title: `You have {{_items.size}} new comments!`,
      imageURL: 'https://app.notificationapi.com/notificationapiLogo.png',
      redirectURL: 'https://notificationapi.com'
    }
  },

  // TODO: test and fill later:
  SMS: {
    templateId: 'default',
    text: 'You have a new comment: {{comment}}'
  },
  CALL: {
    templateId: 'default',
    text: 'This is an automated call from My Company. You have a new comment: {{comment}}. Please visit the dashboard to see more details. Goodbye!'
  },
  PUSH: {
    templateId: 'default',
    message: '{{comment}}',
    title: 'You have a new comment!'
  },
  WEB_PUSH: {
    templateId: 'default',
    title: 'You have a new comment!',
    message: '{{comment}}',
    icon: 'https://app.notificationapi.com/mstile-150x150.png?id={{commentId}}',
    url: 'https://notificationapi.com?commentId={{commentId}}'
  }
};

export default DefaultTemplates;
